import api from "@/lib/api";

const KEY = "aliwer_sid";

export function sessionId() {
  let v = localStorage.getItem(KEY);
  if (!v) {
    v = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, v);
  }
  return v;
}

export function track(event, path) {
  try {
    api.post("/analytics/track", {
      event,
      path: path || window.location.pathname,
      session_id: sessionId(),
    }).catch(() => {});
  } catch {
    /* never block UX on analytics */
  }
}
